import { Link } from "react-router-dom";
import { blogCategories } from "../../../mocks/blog";
import { categoryToSlug } from "../../../utils/blogSlug";

interface BlogFiltersProps {
  active: string;
  counts: Record<string, number>;
}

export default function BlogFilters({ active, counts }: BlogFiltersProps) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {blogCategories.map((cat) => {
        const href = cat === "All" ? "/blog" : `/blog/category/${categoryToSlug(cat)}`;
        const isActive = active === cat;
        return (
          <Link
            key={cat}
            to={href}
            className={`px-4 py-2 rounded-full text-sm font-semibold transition-all cursor-pointer whitespace-nowrap flex items-center gap-1.5 ${
              isActive
                ? "bg-[#222831] text-white"
                : "bg-white text-[#3A506B] border border-[#D9E2EC] hover:border-[#222831] hover:text-[#222831]"
            }`}
          >
            {cat}
            {cat !== "All" && (
              <span
                className={`text-xs font-bold px-1.5 py-0.5 rounded-full ${
                  isActive ? "bg-white/20 text-white" : "bg-[#D9E2EC] text-[#3A506B]"
                }`}
              >
                {counts[cat] ?? 0}
              </span>
            )}
          </Link>
        );
      })}
    </div>
  );
}
